import { render, staticRenderFns } from "./ExaminationRoomBatch.vue?vue&type=template&id=9bbfacea&"
import script from "./ExaminationRoomBatch.vue?vue&type=script&lang=js&"
export * from "./ExaminationRoomBatch.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationRoomBatch.vue?vue&type=style&index=0&id=9bbfacea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports